/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {OktoberfestGameAssets} from "./OktoberfestGameAssets";
import {OktoberfestSound} from "./sound/OktoberfestSound";
import {GameBackground} from "./view/GameBackground";
import {OktoberfestWinPresentation} from "./gameflow/OktoberfestWinPresentation";
import {OktoberfestNormalBetPresentation} from "./gameflow/OktoberfestNormalBetPresentation";
import {OktoberfestNormalResultPresentation} from "./gameflow/OktoberfestNormalResultPresentation";
import {OktoberfestNormalIdlePresentation} from "./gameflow/OktoberfestNormalIdlePresentation";
import {OktoberfestZeroBetIdlePresentation} from "./gameflow/OktoberfestZeroBetIdlePresentation";
import {IOktoberfestGameData} from "./server/data/IOktoberfestData";
import {OktoberfestModel} from "./server/OktoberfestModel";
import {OktoberfestLayers} from "./view/OktoberfestLayers";
import {OktoberfestReelController} from "./reels/OktoberfestReelController";
import {OktoberfestGameConfig} from "./OktoberfestGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {WildLandingController} from "./reelstoppresentation/presentations/WildLandingController";
import {ScatterLandingController} from "./reelstoppresentation/presentations/ScatterLandingController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {OktoberfestFreespinIdlePresentation} from "./gameflow/OktoberfestFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {GameForeground} from "./view/GameForeground";
import {BetLinesView} from "./betLines/BetLinesView";
import {OktoberfestNearWinController} from "./reelstoppresentation/presentations/OktoberfestNearWinController";
import {GameNearWinReelsView} from "./view/GameNearWinReelsView";
import {GameDimOverLay} from "./view/GameDimOverLay";
import {OktoberfestCollectionMeterView} from "./view/OktoberfestCollectionMeterView";
import {OktoberfestMultiplierIndicatorView} from "./view/OktoberfestMultiplierIndicatorView";
import {OktoberfestFreespinsLeftIndicatorView} from "./view/OktoberfestFreespinsLeftIndicatorView";
import {OktoberfestCollectionWPView} from "./view/OktoberfestCollectionWPView";
import {OktoberfestCollectionWPController} from "./winpresentation/presentations/OktoberfestCollectionWPController";
import {OktoberfestReelDividers} from "./view/OktoberfestReelDividers";
import {OktoberfestPartyView} from "./view/OktoberfestPartyView";
import {OktoberfestStackedWildsWPView} from "./view/OktoberfestStackedWildsView";
import {OktoberfestStackedWildsWPController} from "./winpresentation/presentations/OktoberfestStackedWildsWPController";
import {OktoberfestNudgeWildView} from "./view/OktoberfestNudgeWildView";
import {WinEffectView} from "./view/WinEffectView";
import {PretzelPartyController} from "./reelstoppresentation/presentations/PretzelPartyController";
import {OktoberfestPretzelPartyView} from "./view/OktoberfestPretzelPartyView";
import {WildNudgeController} from "./winpresentation/presentations/WildNudgeController";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {IndiSymWinPresentation} from "./winpresentation/presentations/IndiSymWinPresentation";

export class Oktoberfest extends SlotGame {
    public static isActionSpinsActive: boolean = false
    public static model: OktoberfestModel;
    public static gameFlowController: GameFlowController;
    public static assetLoader: AssetLoader;
    public static reels: OktoberfestReelController[];
    public static reelStopPresentations: ReelStopPresentationManager;
    public static winPresentations: WinPresentationManager;
    public static initialCountUp: InitialWinCountUp;
    public static bigWinCountUp: BigWinCountUp;
    public static individualWin: IndividualWinController;
    public static freespinIntro: FreespinIntro;
    public static freespinOutro: FreespinOutro;
    public static winEffectView: WinEffectView;
    public static pretzelPartyView: OktoberfestPretzelPartyView;
    //ReelDividers
    public static reelDividers: OktoberfestReelDividers;
    public static nearWinView: GameNearWinReelsView;
    public static scatterMeter: OktoberfestCollectionMeterView;
    public static stackWPs: OktoberfestStackedWildsWPView;
    //game background
    public static background: GameBackground;
    public static foreground: GameForeground;
    public static nudgeWild: OktoberfestNudgeWildView;
    public static betlines: BetLinesView;
    public static dimOverLay: GameDimOverLay;
    public static fsMultiplier: OktoberfestMultiplierIndicatorView;
    public static leftIndicator: OktoberfestFreespinsLeftIndicatorView;
    public static fsCollectionPresentationView: OktoberfestCollectionWPView;
    public static partyMode: OktoberfestPartyView;
    public static nudgeWildCont: WildNudgeController;


    constructor() {
        super();
    }

    public static get isIpad(): boolean {
        const resizeData: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            return (resizeData.width >= 955 && resizeData.width <= 965);
        } else {
            return (resizeData.height >= 955 && resizeData.height <= 965);
        }
    }

    public async init(): Promise<NolimitPlugin> {
        const value = await super.init();

        OktoberfestGameConfig.updateReelSets();
        Oktoberfest.model = new OktoberfestModel(SlotGame.apiPlugin, true);
        Oktoberfest.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Oktoberfest.model);
        Oktoberfest.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        //Example
        Oktoberfest.model.events?.on(GameModelEvent.GAME, (data: IOktoberfestGameData) => {
            console.log(data);
        });

        const idleNormal = new OktoberfestNormalIdlePresentation();
        const reelStart = new OktoberfestNormalBetPresentation();
        const normalResult = new OktoberfestNormalResultPresentation();
        const freespinIdle = new OktoberfestFreespinIdlePresentation();
        const zeroBetIdle = new OktoberfestZeroBetIdlePresentation();
        const winPres = new OktoberfestWinPresentation();

        Oktoberfest.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, idleNormal],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        Oktoberfest.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres],
        ]));
        Oktoberfest.gameFlowController.addGameModeFlowStatePresentationMap("WILD_RESPIN", new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, zeroBetIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres],
        ]));
        return value;
    }

    public async getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);
        AssetsConfig.addToAssetsConfig(OktoberfestGameAssets.RESOURCES_GROUPS);
        Oktoberfest.assetLoader = new AssetLoader(Oktoberfest.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        await Promise.all([fontLoader.load(), Oktoberfest.assetLoader.load(ResourcesGroupName.MAIN)]);
        await this.createViewsAndComponents();
        return value;
    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        Oktoberfest.leftIndicator.onGameReady();
        OktoberfestSound.switchMusic(
            {name: OktoberfestSound.MAIN_GAME_MUSIC, volume: 0},
            {name: OktoberfestSound.MAIN_GAME_MUSIC, from: 0, to: 1, duration: 1000}
        );

        return await super.getReadyToStart();
    }

    public async start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.

        const value = await super.start();

        Oktoberfest.gameFlowController.start();
        OktoberfestSound.switchMusic({name: OktoberfestSound.getMusicNameByMode(Oktoberfest.model.data.mode)});

        return value;
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "M2",
                    "M3",
                    "M1",
                    "L2",
                    "L4",
                    "S",
                    "M2"
                ],
                [
                    "M4",
                    "L4",
                    "L5",
                    "M1",
                    "L3",
                    "M3",
                    "M1"
                ],
                [
                    "L3",
                    "M5",
                    "M2",
                    "L4",
                    "M4",
                    "L3",
                    "L2"
                ],
                [
                    "L1",
                    "M3",
                    "L2",
                    "L3",
                    "W",
                    "W",
                    "W"
                ],
                [
                    "L5",
                    "M5",
                    "M3",
                    "L5",
                    "L2",
                    "M4",
                    "L1"
                ]
            ],
            "mode": "NORMAL",
            "totalSpinWinnings": 0,
            "betLineWins": [],
            "freespinsLeft": 0,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "beerTokenCollectedInFreespin": 0,
            "beerTokensCollectedThisSpin": 0,
            "overLayWilds": [
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null
                ]
            ],
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "respinsLeft": 0,
            "previousRespin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "freespinTriggeredThisSpin": false,
            "reelsNextSpin": "BASE_REELSET",
            "nextMode": "NORMAL",
            "multiplierBeforeSpin": 1,
            "multiplierAfterSpin": 1,
            "freespinsLeftBeforeSpin": 0,
            "freespinsLeftAfterSpin": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 2,
            "addedMultiplierThisSpin": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "winSize": ""
        };
    }

    private createViewsAndComponents() {
        //Non views
        const sound = new OktoberfestSound();
        const layers = new OktoberfestLayers();

        //Views
        Oktoberfest.initialCountUp = new InitialWinCountUp();
        Oktoberfest.bigWinCountUp = new BigWinCountUp();
        Oktoberfest.reels = [];
        Oktoberfest.scatterMeter = new OktoberfestCollectionMeterView();
        Oktoberfest.fsMultiplier = new OktoberfestMultiplierIndicatorView();
        Oktoberfest.leftIndicator = new OktoberfestFreespinsLeftIndicatorView();
        Oktoberfest.fsCollectionPresentationView = new OktoberfestCollectionWPView();
        Oktoberfest.winEffectView = new WinEffectView();
        Oktoberfest.partyMode = new OktoberfestPartyView();
        Oktoberfest.stackWPs = new OktoberfestStackedWildsWPView();
        Oktoberfest.pretzelPartyView = new OktoberfestPretzelPartyView();
        Oktoberfest.reelDividers = new OktoberfestReelDividers();
        Oktoberfest.nearWinView = new GameNearWinReelsView();
        Oktoberfest.foreground = new GameForeground();
        Oktoberfest.nudgeWild = new OktoberfestNudgeWildView();
        Oktoberfest.dimOverLay = new GameDimOverLay();
        Oktoberfest.background = new GameBackground();
        for (let i: number = 0; i < OktoberfestGameConfig.REELS_NUM; i++) {
            const reel = new OktoberfestReelController(i);
            Oktoberfest.reels.push(reel);
        }
        Oktoberfest.nudgeWildCont = new WildNudgeController();
        Oktoberfest.reelStopPresentations = new ReelStopPresentationManager([
            new PretzelPartyController(),
            new ReelStopSoundController(),
            new WildLandingController(),
            new ScatterLandingController(),
            new OktoberfestNearWinController(),
        ]);
        Oktoberfest.winPresentations = new WinPresentationManager([
            new OktoberfestStackedWildsWPController(),
            new OktoberfestCollectionWPController(),
            new NoWinSymbolsController(),
            new IndiSymWinPresentation(),
            new InitialWinController(),
            new BigWinController(),
            new FreespinWinController(),
            new FreespinEndController(),
        ]);
        if (Oktoberfest.model.isRestore && Oktoberfest.model.parsedInitData.showTotalWin) {
            SlotGame.keypadPlugin.setWin(Oktoberfest.model.parsedInitData.totalWin, true);
        }
        Oktoberfest.individualWin = new IndividualWinController();
        Oktoberfest.betlines = new BetLinesView();
        Oktoberfest.freespinIntro = new FreespinIntro();
        Oktoberfest.freespinOutro = new FreespinOutro();
        Oktoberfest.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
            if (data) {
                Oktoberfest.individualWin.stop();
            }
            //in some cases data can be undefined so making it a boolean
            Oktoberfest.isActionSpinsActive = !!data;
        })
        // If restore, can be handled in these constructors directly.
    }
}